import { render, staticRenderFns } from "./ArticleVersionRestoreNotificationContent.vue?vue&type=template&id=46b719f0&"
import script from "./ArticleVersionRestoreNotificationContent.vue?vue&type=script&lang=ts&"
export * from "./ArticleVersionRestoreNotificationContent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports